import { combineReducers } from 'redux'
import orderEntries from './DeliveryOrderReducer'
import { sizes, showSizes, showSizes2 } from './SizesReducer'
import { inventory } from './InventoryReducer'
import { newArticleType, updatedArticleType } from './NewArticleTypeReducer'
import addStock from './AddStockReducer'

export default combineReducers({
    orderEntries,
    sizes,
    showSizes,
    showSizes2,
    inventory,
    newArticleType,
    updatedArticleType,
    addStock,
})